import { t } from "i18next";
import { FieldErrors, UseFormRegister } from "react-hook-form";

type FormFieldProps = {
  field: {
    label: string;
    name: string;
    type: string;
    required: boolean;
  };
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  placeholder?: string;
};

const FormField = ({
  field,
  register,
  errors,
  placeholder,
}: FormFieldProps) => {
  return (
    <div>
      <label className="block text-sm font-medium text-gray-700">
        {field.label}
        {field.required && <span className="text-red-500">*</span>}
      </label>
      {field.type === "textarea" ? (
        <textarea
          {...register(field.name, {
            required: t("required"),
          })}
          className="mt-1 block w-full rounded-lg border border-gray-300 p-2 focus:border-blue-500 focus:ring-blue-500"
          placeholder={placeholder}
        ></textarea>
      ) : (
        <input
          type={field.type}
          {...register(field.name, {
            required: t("required"),
            ...(field.type === "email" && {
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: t("Invalid email address"),
              },
            }),
          })}
          className="mt-1 block w-full rounded-lg border border-gray-300 p-2 focus:border-blue-500 focus:ring-blue-500"
          placeholder={placeholder}
        />
      )}
      {errors[field.name] && (
        <p className="mt-1 text-sm text-red-500">
          {(errors[field.name as string]?.message ?? "") as string}
        </p>
      )}
    </div>
  );
};

export default FormField;
